module.exports = __webpack_public_path__ + "static/cable-14-5193951d6a66352a8f91c81c5d260ae0.png";